import generateUniqueId from 'common/generate-unique-id'

export default () => `${generateUniqueId()}${generateUniqueId()}`
